import { Component, Input, OnInit, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import {DemoService} from '../../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router, ActivatedRoute} from '@angular/router';

// import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';

import { enableRipple } from '@syncfusion/ej2-base';
// enable ripple effects
enableRipple(true);
import { DataManager, ODataAdaptor, WebApiAdaptor, UrlAdaptor,Query, ReturnOption, DataUtil  } from '@syncfusion/ej2-data';
import { MenuItemModel } from '@syncfusion/ej2-angular-navigations';
import { PageSettingsModel, FilterSettingsModel } from '@syncfusion/ej2-grids';

import { ChangeEventArgs } from '@syncfusion/ej2-inputs';
import { createElement } from '@syncfusion/ej2-base';
import {  IFilter, RowSelectEventArgs, SelectionSettingsModel, TextWrapSettingsModel } from '@syncfusion/ej2-angular-grids';
import { GridComponent, ToolbarItems, ToolbarService, ExcelExportService, GroupSettingsModel,
RowDataBoundEventArgs  } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';


import { FilterService, IFilterUI, Column } from '@syncfusion/ej2-angular-grids';
import { DatePicker } from '@syncfusion/ej2-calendars';
import { parentsUntil } from '@syncfusion/ej2-grids';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GlobalFunctionsService } from './../../../services/global-functions.service';
import { map, Observable } from 'rxjs';
import { TabsetComponent } from 'ngx-bootstrap/tabs';
import { Brand } from 'src/app/shared/models/brand.model';
import { BsModalService } from 'ngx-bootstrap';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Component({
  selector: 'app-myob-customers-grid',
  templateUrl: './myob-customers-grid.component.html',
  styleUrls: ['./myob-customers-grid.component.css']
})
export class MyobCustomersGridComponent implements OnInit {

  @Input() sent_data?: any; // not used

  // Grid Vars
  public data: DataManager;
  public data_subjects: DataManager;
  public pageSettings: Object;
  public pageOptions = { pageSize: 25 }; 
  public filterOptions: FilterSettingsModel;
  public formatOptions: Object;
  // public filterOptions: FilterSettingsModel;
  public filter : IFilter;
  public toolbarOptions: ToolbarItems[];
  @ViewChild('grid')
  public grid: GridComponent;
  @ViewChild('comparitor_grid')
  public comparitor_grid: GridComponent;
  
  
  public groupOptions: GroupSettingsModel;
  public groupOptions_Comparison: GroupSettingsModel;
  public templateOptionsDate: IFilterUI;
  public elem1: HTMLElement;
  public datePickerObj: DatePicker;
  //checkbox selection options
  public selectionOptions: SelectionSettingsModel;
  public selIndex: number[] = [];
  subjects_urgent: any;
  formatoptions: { type: string; format: string; };
  dateFormat: string;
  sortOptions: { columns: { field: string; direction: string; }[]; };

  public wrapSettings: TextWrapSettingsModel;
  // public wrapSettings: { wrapMode: 'Content' | 'Both' | 'Header' }; // this allows the content to wrap only Header|Content|Both
  // public wrapSettings: TextWrapSettingsModel; // this allows the content to wrap only Header|Content|Both

      // TABS sets the selected
      @ViewChild('staticTabs') staticTabs: TabsetComponent;
      
      // today = new Date().toISOString(); // this date worked to compare dates with ZISo date format in database.
      // today_name_file = this.datepipe.transform(this.today, 'dd-MM-yyyy-hhmmss'); // formats date for comparison
      // action_day = this.datepipe.transform(this.today, 'ddMMyyyy'); // formats date for comparison
      // action_day_words = this.datepipe.transform(this.today, 'EEEEMMMd-y'); // formats date for comparison




      
  today = new Date();
  initialPage: { pageSize: number; };
  open_jobs_count: any;
  myobCustomers: Object;
  arrCase: object[];
  Items: any;
  myobCustomerCreatedData: any;
  brand_types: any;
  users: any;
  usersPrimary: any;
  job_table_clients: any;
  btLocalRecord: any;
  changeObject: any;
  userLocalRecord: any;
  job_table_clients3: any;
  UID_new_customer: any;
  returned_update: Object;
  myobCustomerDeleteData: Object;
  myobCustomerUpdateData: Object;
  customerItem: any;
  myobContactListMapped: any;
  myobCustomer: Object;
  set_RowVersion: any;
  IsIndividual: any;
  sessionUserId: any;
  sessionUsername: any;
  sessionBrandId: any;
  all_router_details: string;
  difference_results: any[];
  comparitor_array: any[];
  baseMyobCustomers: any;
  search_results: any;
  selectedrecords: object[];
  Items2: any;
  comparitor_array_B: any;
  comparitor_array_A: any;
  search_model: Brand;
  brands_client: any;

  isShow_search = false;
  isShow_quickSearch= false;

  public brand_fields: Object = { text: 'NameAndAddress', value: 'brand_id' }; // using the name field not id!
  client_fields: Object = { text: 'user_full_name', value: 'user_id' };
  modalRef: any;

  

  constructor(
    private http: HttpClient, private router: Router,
    private route: ActivatedRoute, private _demoService: DemoService,
   public datepipe: DatePipe,  public gfunc: GlobalFunctionsService,
   public toastr: HotToastService,
   vcr: ViewContainerRef,
   private modalService: BsModalService,
  ) { 
   
    // Set and Access login Session Variables
 this.gfunc.setLoginSessionVars(); // set in a global function file
 this.sessionUserId = this.gfunc.currentUserVAR.user_id;
 this.sessionUsername = this.gfunc.currentUserVAR.username;
 this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;

      // need to add this as routes does not work globally
      this.all_router_details = this.router.url;
      this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));
  }


  
  ngOnInit() {
    // this.comparitor_array = [];
              // // load the SOP Brands/Clients
              // this.mapJobTableLiveClients();

              //     // Load the data
              //           this.getMyobCustomers();

              this.search_model = new Brand();
              this.search_model.sync_with_myob = '1'; 
              this.getBrandsComboBoxClients(this.search_model);
    
              this.searchPushedClients48()

          // Grid Options
          this.toolbarOptions = ['ExcelExport', 'Search'];
          this.initialPage = { pageSize:5 };
          this.filterOptions = {
             type: 'Menu'
          };
         
          // Helps for the comparison grid... using same group settings.
          // just make this two different ones if I need different... 

          this.groupOptions = {  }; // sets auto grouping for the grid
          this.groupOptions_Comparison = { columns: ['brand_id'] }; // sets auto grouping for the grid


          this.formatoptions= {type:'date', format:'dd/MM/yyyy'};
          this.dateFormat = 'dd/MM/yyyy hh:mm a';
          this.filter = { params: { format: this.dateFormat } };
         // this.sortOptions = { columns: [{ field: 'job_id', direction: 'Descending' } ] };
         this.pageOptions = { pageSize: 100 }; 
      
         this.wrapSettings = { wrapMode: 'Content' }; // this allows the content to wrap only Header|Content|Both

              //checkbox selection options
      // this.selectionOptions = { checkboxMode: 'ResetOnRowClick'}; // type: 'Multiple', mode: 'Both
      this.selectionOptions = { type: 'Multiple', mode: 'Both'}; // 

      // end date filter options
          // End Grid Options

          // DID NOT WORK AS I HVE NOT GOT MATCHING ARRAYS
          // Gets the difference between the two arrays
          // this.difference_results = this.difference(this.job_table_clients, this.sent_data)




  }


  // ngOnChanges(){
  //   this.searchPushedClients48()
  // }

  // :: Grid Functions


// https://ej2.syncfusion.com/angular/documentation/grid/tool-bar/#built-in-and-custom-items-in-toolbar
clickHandler(args: ClickEventArgs): void {
  if (args.item.id === 'Click') {

  //  this.grid.showSpinner();

  //    alert('This function will trigger the action to Emails, and Status Notifications to Agents');
 //  console.log(args.data.items);
 


  let pdfdata;
  const query = this.grid.renderModule.data.generateQuery(); // get grid corresponding query
  for (let i = 0; i < query.queries.length; i++) {
    if (query.queries[i].fn === 'onPage') {
      query.queries.splice(i, 1);       // remove page query to get all records
      break;
    }
  }
  const fdata = new DataManager({ json: this.subjects_urgent }).executeQuery(query).then((e: any) => {
    pdfdata = e.result as object[];  // get all filtered records
    const exportProperties = {
      dataSource: pdfdata,
    };
    // console.log(pdfdata.results);

   // this.search_results = pdfdata.records; // need this if a grouping is set.
  /*   this.search_results = pdfdata;
    this.toastr.info( this.search_results.length + ' subjects added to the update Request Que'); 
    this.toastr.success( "Press Start To Process Que");  */
   // this.grid.pdfExport(exportProperties);
  }).catch((e) => true);
  }

 //  this.grid.hideSpinner();

};


toolbarClick(args: ClickEventArgs): void {
  if (args.item.id === 'Grid_excelexport') { // 'Grid_excelexport' -> Grid component id + _ + toolbar item name
      this.grid.excelExport();
  }
}
// rowDataBound(args: RowDataBoundEventArgs) {
//   const job_status = 'job_status';
//   if (args.data[job_status] === 'CLOSED') {
//       args.row.className = 'strikethrough';
//   }
// }


rowDataBound(args: RowDataBoundEventArgs) {
  const job_status = 'payment_status';
    if (args.data[job_status] === 'OVERDUE') {
        args.row.className = 'text-danger';
    }
    const status = 'status'
    if (args.data[status] === 'completed' || args.data[status] === 'on-hold' || args.data[status] === 'cancelled'  ) {
      args.row.className = 'text-muted';
      // disable the check box for complete / onhold / refunded orders.
      args.row.getElementsByClassName('e-gridchkbox')[0].classList.add('disablecheckbox'); 
      args.row.getElementsByClassName('e-checkbox-wrapper')[0].classList.add('disablecheckbox') 
      }

      // Disable if not even have a myob ID
      const RowVersion = 'RowVersion'
      if (args.data['UID'] == '' ) {
        args.row.className = 'text-muted';
        // disable the check box for complete / onhold / refunded orders.
        args.row.getElementsByClassName('e-gridchkbox')[0].classList.add('disablecheckbox'); 
        args.row.getElementsByClassName('e-checkbox-wrapper')[0].classList.add('disablecheckbox') 
        }
}

public dataBound(args): void {
  if (this.selIndex.length) {
      this.grid.selectRows(this.selIndex);
      this.selIndex = [];
  }
}

      /// TABS
      selectTab(tab_id: number) {
        this.staticTabs.tabs[tab_id].active = true;
      };


  // :: Grid Functions

  // uses demo services but calls to myob
  public getMyobCustomers() {
    return  this._demoService.getMyobCustomers().subscribe(
        data => { this.myobCustomers = data;
          const res = data[0];
           // https://www.concretepage.com/questions/577
           this.arrCase = data as object [];  // FILL THE ARRAY WITH DATA.
           // console.log(this.arrCase);
           this.Items = data['Items'] ;
           this.sent_data = this.Items;
          // this.toastr.info('Myob Datas Gathered')
           // console.log(this.Items);
          // this.Address = this.Items['Address'];
    // return this.myobCustomers;
  
    // this.comparitor_array = [];
    // this.baseMyobCustomers.items = DataUtil.parse.parseJson(data); 
    // this.baseMyobCustomers = DataUtil.parse.parseJson(data); 


        



    this.baseMyobCustomers =  this.Items;
   // console.log(JSON.stringify(this.baseMyobCustomers))
  //  console.log(JSON.stringify(this.Items))
    
    if (!this.comparitor_array){this.comparitor_array = [];}
    if (!this.comparitor_array_B){this.comparitor_array_B = [];}

  // Count items and then push to the comparitor array with same being sent from the myob call.
        // let  count_of_items = Object.keys(this.baseMyobCustomers).length;
        let  count_of_items = this.baseMyobCustomers.length;
        console.log("Count of items: " + count_of_items);


        // const localTaxAccountsLInkedArr = Object(this.myob_tax_codes).filter((ac) => (ac.UID === model.UID)); // filter array of already looked up myob_account_codes data
        // console.log('LocalCheckCount: ' + localTaxAccountsLInkedArr.length );
        // const local_account_check_length = localTaxAccountsLInkedArr.length;


        

        // // now loop and push to join model
        for(let i=0;i < count_of_items; i++) {
          let res_push = this.baseMyobCustomers[i];


          // -- Add a new check here to see if apart of the search_resulss "customers array" and if so then push... if not then skip the push
          // This should allow the search_model to filter the Results as well, then push again....



        
// console.log("Tax code: " + res_push.SellingDetails.FreightTaxCode.UID)

            // push to holding list of invoice items, all current subject_billing_items. (no filtering as yet.)
            this.comparitor_array.push({
              CompanyName: res_push.CompanyName,
              UID: res_push.UID,
              RowVersion: res_push.RowVersion,
              TaxCode: res_push.SellingDetails.TaxCode.UID,
              FreightTaxCode: res_push.SellingDetails.FreightTaxCode.UID,
              // TaxCode: res_push.SellingDetails,
              // FreightTaxCode: '',
              brand_id: res_push.DisplayID,
              name: '',
              via: 'MYOB',
              real_brand_id: null,
              LastModified: res_push.LastModified

                    });

            this.comparitor_array_B.push({
              CompanyName: res_push.CompanyName,
              UID: res_push.UID,
              RowVersion: res_push.RowVersion,
              TaxCode: res_push.SellingDetails.TaxCode.UID,
              FreightTaxCode: res_push.SellingDetails.FreightTaxCode.UID,
              // TaxCode: res_push.SellingDetails,
              // FreightTaxCode: '',
              brand_id: res_push.DisplayID,
              name: '',
              via: 'MYOB',
              real_brand_id: null,
              LastModified: res_push.LastModified
                    });       
        
        } // end brands loop.
       this.comparitor_array =  this.comparitor_array;
       this.comparitor_grid.refresh(); // refreshes this grid
      //  this.toastr.success("Myob customers pushed to comparitor array");




    // Map the data top the new model system
   // this.Items.map(data => data.map(data => new MyobContact().deserialize(data)));
  
        },
        err => {
          // this.toastr.error('You need to login to MYOB again, Connection lost!');
         // console.error(err);
        },
        // () => console.log('done loading Trace Types')
      );
  
    }

    createMyobCustomer(model){
      return  this._demoService.createMyobCustomer(model).subscribe(
        data => { this.myobCustomerCreatedData = data;
          const res = data[0];
         
          // // https://www.concretepage.com/questions/577
          //  this.arrCase = data as object [];  // FILL THE ARRAY WITH DATA.
          //  // console.log(this.arrCase);
          //  this.Items = data['Items'] ;

  
        },
        err => {
          // this.toastr.error('You need to login to MYOB again, Connection lost!');
         // console.error(err);
        },
        // () => console.log('done loading Trace Types')
      );

    }



    
    createMyobCustomerModel(model){
      if (confirm('We are about to Sync this Business with MYOB as a client/customer, Are you Sure?')) {

      // :: Need to create a new customer model based on myob defaul and required fields for insert of new customer
      const data2 = {
        'CompanyName': model.name,
        'LastName': model.surname,
        'FirstName': model.name,
        'IsIndividual': false,
        'DisplayID': 'TSA' + model.brand_id,
        'IsActive' : true,

        'Addresses' : [
          {
          'Location' : 1,
          'Street' : model.adddress_1,
          'City' : model.suburb,
          'State' : model.state,
          'PostCode' : model.postcode,
          'Country' : model.country,
          'Phone1' : model.phone,
          'Phone2' : '',
          'Phone3' : '',
          'Fax' : model.fax,
          'Email' : model.accounts_email_address, // set as the accounts email Address always for myob
          'Website' : model.website,
          'ContactName' : '',
          'Salutation' : ''
          }
          ],
          'Notes' : model.brand_notes,

          'CustomField1' : {
            'Label' : 'brand_id',
            'Value' : model.brand_id
            },

        'SellingDetails': {
            'SaleLayout' : 'NoDefault',
            'PrintedForm' : 'null',
            'InvoiceDelivery' : 'Print',
            'ABN' : model.abn,
            'TaxCode': {
              'UID':this.gfunc.myob_TaxCode,
              'Code': 'GST'
              // "URI": "https://arl2.api.myob.com/accountright/8449d6c9-2fdc-412a-8412-b6c0a058beba/GeneralLedger/TaxCode/8d273078-fe1d-4c16-b318-ec7a2b7fb2fe"
            },
            'FreightTaxCode': {
              'UID': this.gfunc.myob_FreightTaxCode,
              'Code': 'GST'
              // "URI": "https://arl2.api.myob.com/accountright/8449d6c9-2fdc-412a-8412-b6c0a058beba/GeneralLedger/TaxCode/8d273078-fe1d-4c16-b318-ec7a2b7fb2fe"
            }
          }
        // "UseCustomerTaxCode": false
       };



// :: Ideally need to get a response from insert of the UID of the customer to insert back in sop brands to know th e link has taken place.
        this._demoService.createMyobCustomer(data2).subscribe(
        data => { this.myobCustomerCreatedData = data;
          let res = data[0];
          let new_data_object = JSON.parse(this.myobCustomerCreatedData);

          // console.log('new_data date: ' + new_data_object.date);
          // console.log('new_data Location ' + new_data_object.location);
          // remove the last 25 chars to get the inserted id.
          // get the length of the string and then splice 25 chars less from the total length.
          let location_string = new_data_object.location;
          // let data_object_length = location_string.length;
          // let start_from = data_object_length - 25;
          // let data_object_splice = location_string.slice( start_from , data_object_length);
          // this.UID_new_customer = data_object_splice;
          // console.log('Last inserted myobID: ' + this.UID_new_customer);

          // get everything after last dash 
          let slug = location_string.split('/').pop(); // 2020
          console.log('UUID slug: ' + slug);

          model.myob_id = slug;
          model.sync_with_myob = 1;



          // :: Need to lookup myoub get UID/myobid and fill rest of model.vars.



                    // need to pass the brand model here as its updatting the full SOP brand details.
                    this._demoService.getMyobCustomerMapped(slug, model).subscribe(
                       data4 => {
                        console.log(data4);
                        res = data4[0];
                      // many
                        // this.myobContactListMapped = data.data;
                      //single
                        this.myobContactListMapped = data4;
                      // Set the returned Variables Reququied for Update of a Myob Customer.
                      console.log('UID: ' +  data4.UID);
                      console.log('LastModified: ' + data4.LastModified);
                      console.log('RowVersion: ' + data4.RowVersion);
                      console.log('TaxCodeUID: ' +  data4.SellingDetails.TaxCode.UID);
                      console.log('Sale Layout: ' +  data4.SellingDetails.SaleLayout);

                      this.set_RowVersion = data4.RowVersion;
                      this.IsIndividual = data4.IsIndividual;

                      model.IsIndividual = data4.IsIndividual;
                      model.SaleLayout = data4.SellingDetails.SaleLayout;
                      model.InvoiceDelivery = data4.SellingDetails.InvoiceDelivery;
                      model.TaxCode = data4.SellingDetails.TaxCode.UID;
                      model.FreightTaxCode = data4.SellingDetails.FreightTaxCode.UID;
                      model.RowVersion = data4.RowVersion;
                      model.myob_customer_array = JSON.stringify(data4);

                      this.editBrand(model);
                      this.refreshGrid();
                      this.toastr.info('Customer Upgraded In SOP');
                    },
                    error => {
                      // console.error('Error saving Event!');
                       this.toastr.error('Error Updating Brand Myob Details');
                      console.log(error.error);
                     });

                     model.IsIndividual = this.IsIndividual;
                     model.RowVersion = this.set_RowVersion;

   
                      
                        //  model.RowVersion = this.set_RowVersion;
                    //  model.myob_customer_array = JSON.stringify(this.myobContactListMapped);


          // let new_data_string = JSON.stringify(this.myobCustomerCreatedData);
          // console.log('new_data date: ' + new_data_string.date);
          // console.log('new_data date: ' + new_data_string.location);

          // console.log(this.myobCustomerCreatedData.location);
          // // https://www.concretepage.com/questions/577
          //  this.arrCase = data as object [];  // FILL THE ARRAY WITH DATA.
          //  // console.log(this.arrCase);
          //  this.Items = data['Items'] ;

        
        },
        err => {
          // this.toastr.error('You need to login to MYOB again, Connection lost!');
         console.log(err.error);
        },
        // () => console.log('done loading Trace Types')
      );

      }; // end confirm

    };



    updateMyobCustomerModel2(model){
      if (confirm('We are about to Sync this Business with MYOB and update the myob data, Are you Sure?')) {
        let data_test = {
          'UID': model.myob_id,
          'CompanyName': model.name,
          'LastName': 'My Crazy Name',
          'FirstName': 'Tester',
          'IsIndividual': false,
          'DisplayID': 'TSA' + model.brand_id,
          'Addresses' : [
            {
            'Location' : 1,
            'Street' : model.adddress_1,
            'City' : model.suburb,
            'State' : model.state,
            'PostCode' : model.postcode,
            'Country' : model.country,
            'Phone1' : model.phone,
            'Phone2' : '',
            'Phone3' : '',
            'Fax' : model.fax,
            'Email' : model.accounts_email_address, // set as the accounts email Address always for myob
            'Website' : model.website,
            'ContactName' : '',
            'Salutation' : ''
            },
            {
              'Location' : 2,
              'Street' : model.postal_address_1,
              'City' : model.postal_suburb,
              'State' : model.postal_state,
              'PostCode' : model.postal_postcode,
              'Country' : model.postal_country,
              'Phone1' : model.phone,
              'Phone2' : '',
              'Phone3' : '',
              'Fax' : model.fax,
              'Email' : model.accounts_email_address, // set as the accounts email Address always for myob
              'Website' : model.website,
              'ContactName' : '',
              'Salutation' : ''
              }
            ],
            'Notes' : model.brand_notes,
  
            'CustomField1' : {
              'Label' : 'brand_id',
              'Value' : model.brand_id
              },
  
                            'SellingDetails': {
                'ABN': model.abn,
                'TaxCode': {
                  'UID': this.gfunc.myob_TaxCode
                },
                'FreightTaxCode': {
                  'UID': this.gfunc.myob_FreightTaxCode
                }
          },
          'RowVersion': model.RowVersion,
        };


  this._demoService.updateMyobCustomer(data_test).subscribe(
        data => { this.myobCustomerUpdateData = data;
          let res = data[0];
        
          // turned below into a function to reuse?
        this.lookupCustomerUpdateBrand(model.myob_id, model);
          // model.myob_id = null;
          // model.sync_with_myob = 0;

               // need to pass the brand model here as its updatting the full SOP brand details.
            //    this._demoService.getMyobCustomerMapped(model.myob_id, model).subscribe(
            //     data4 => {
            //      console.log(data4);
            //      res = data4[0];
            //      this.myobContactListMapped = data4;
            //    // Set the returned Variables Reququied for Update of a Myob Customer.
            //   //  console.log('UID: ' +  data4.UID);
            //   //  console.log('LastModified: ' + data4.LastModified);
            //   //  console.log('RowVersion: ' + data4.RowVersion);
            //   //  console.log('TaxCodeUID: ' +  data4.SellingDetails.TaxCode.UID);
            //   //  console.log('Sale Layout: ' +  data4.SellingDetails.SaleLayout);

            //    this.set_RowVersion = data4.RowVersion;
            //    this.IsIndividual = data4.IsIndividual;

            //    model.IsIndividual = data4.IsIndividual;
            //    model.SaleLayout = data4.SellingDetails.SaleLayout;
            //    model.InvoiceDelivery = data4.SellingDetails.InvoiceDelivery;
            //    model.TaxCode = data4.SellingDetails.TaxCode.UID;
            //    model.FreightTaxCode = data4.SellingDetails.FreightTaxCode.UID;
            //    model.RowVersion = data4.RowVersion;
            //    model.myob_customer_array = JSON.stringify(data4);

            //    this.editBrand(model);
            //    this.refreshGrid();
            //    this.toastr.info('CustomerVrs Updated In SOP');
            //  },
            //  error => {
            //    // console.error('Error saving Event!');
            //     this.toastr.error('Error Updating Brand Myob Details');
            //    console.log(error.error);
            //   });


          // this.editBrand(model);
          //   this.refreshGrid();
          this.toastr.success('Brand Details updated with Myob');
        },
        err => {
          // this.toastr.error('You need to login to MYOB again, Connection lost!');
         // console.error(err);
        },
        // () => console.log('done loading Trace Types')
      );

      }; // end confirm

    };



lookupCustomerUpdateBrand(UID, model){
  this._demoService.getMyobCustomerMapped(UID, model).subscribe(
    data4 => {
     console.log(data4);
     let res = data4[0];
     this.myobContactListMapped = data4;
   // Set the returned Variables Reququied for Update of a Myob Customer.
  //  console.log('UID: ' +  data4.UID);
  //  console.log('LastModified: ' + data4.LastModified);
  //  console.log('RowVersion: ' + data4.RowVersion);
  //  console.log('TaxCodeUID: ' +  data4.SellingDetails.TaxCode.UID);
  //  console.log('Sale Layout: ' +  data4.SellingDetails.SaleLayout);

   this.set_RowVersion = data4.RowVersion;
   this.IsIndividual = data4.IsIndividual;

   model.IsIndividual = data4.IsIndividual;
   model.SaleLayout = data4.SellingDetails.SaleLayout;
   model.InvoiceDelivery = data4.SellingDetails.InvoiceDelivery;
   model.TaxCode = data4.SellingDetails.TaxCode.UID;
   model.FreightTaxCode = data4.SellingDetails.FreightTaxCode.UID;
   model.RowVersion = data4.RowVersion;
   model.myob_customer_array = JSON.stringify(data4);

   this.editBrand(model);
   this.refreshGrid();
   this.toastr.info('CustomerVrs Updated In SOP');
 },
 error => {
   // console.error('Error saving Event!');
    this.toastr.error('Error Updating Brand Myob Details');
   console.log(error.error);
  });
}; // end loopup and update function




    updateMyobCustomerModel(model){
      if (confirm('We are about to Sync this Business with MYOB and update the myob data, Are you Sure?')) {

      // :: Need to create a new customer model based on myob defaul and required fields for insert of new customer
      let data3 = {
        'UID': model.myob_id, // update field
        'CompanyName': model.name,
        'LastName': model.surname,
        'FirstName': model.name,
        'IsIndividual': true,
        'DisplayID': 'TSA' + model.brand_id,
        'IsActive' : true,

        'Addresses' : [
          {
          'Location' : 1,
          'Street' : model.adddress_1,
          'City' : model.suburb,
          'State' : model.state,
          'PostCode' : model.postcode,
          'Country' : model.country,
          'Phone1' : model.phone,
          'Phone2' : '',
          'Phone3' : '',
          'Fax' : model.fax,
          'Email' : model.accounts_email_address, // set as the accounts email Address always for myob
          'Website' : model.website,
          'ContactName' : '',
          'Salutation' : ''
          },
          {
            'Location' : 2,
            'Street' : model.postal_address_1,
            'City' : model.postal_suburb,
            'State' : model.postal_state,
            'PostCode' : model.postal_postcode,
            'Country' : model.postal_country,
            'Phone1' : model.phone,
            'Phone2' : '',
            'Phone3' : '',
            'Fax' : model.fax,
            'Email' : model.accounts_email_address, // set as the accounts email Address always for myob
            'Website' : model.website,
            'ContactName' : '',
            'Salutation' : ''
            }
          ],
          'Notes' : model.brand_notes,

          'CustomField1' : {
            'Label' : 'brand_id',
            'Value' : model.brand_id
            },

        'SellingDetails': {
            'SaleLayout' : model.SaleLayout,
            'PrintedForm' : 'null',
            'InvoiceDelivery' : model.InvoiceDelivery,
            'ABN' : model.abn,
            'TaxCode': {
              'UID': model.TaxCode,
            },
            'FreightTaxCode': {
              'UID': model.FreightTaxCode,
            }
          },
        // "UseCustomerTaxCode": false
        'RowVersion': model.RowVersion, // update field.
       };


       let data_test = {
        'UID': model.myob_id,
        'CompanyName': model.name,
        'LastName': 'My Crazy Name',
        'FirstName': 'Tester',
        'IsIndividual': false,
        'DisplayID': 'TSA' + model.brand_id,
        'Addresses' : [
          {
          'Location' : 1,
          'Street' : model.adddress_1,
          'City' : model.suburb,
          'State' : model.state,
          'PostCode' : model.postcode,
          'Country' : model.country,
          'Phone1' : model.phone,
          'Phone2' : '',
          'Phone3' : '',
          'Fax' : model.fax,
          'Email' : model.accounts_email_address, // set as the accounts email Address always for myob
          'Website' : model.website,
          'ContactName' : '',
          'Salutation' : ''
          },
          {
            'Location' : 2,
            'Street' : model.postal_address_1,
            'City' : model.postal_suburb,
            'State' : model.postal_state,
            'PostCode' : model.postal_postcode,
            'Country' : model.postal_country,
            'Phone1' : model.phone,
            'Phone2' : '',
            'Phone3' : '',
            'Fax' : model.fax,
            'Email' : model.accounts_email_address, // set as the accounts email Address always for myob
            'Website' : model.website,
            'ContactName' : '',
            'Salutation' : ''
            }
          ],
          'Notes' : model.brand_notes,

          'CustomField1' : {
            'Label' : 'brand_id',
            'Value' : model.brand_id
            },

        'SellingDetails': {
          'TaxCode': {
            'UID': this.gfunc.myob_TaxCode
          },
          'FreightTaxCode': {
            'UID': this.gfunc.myob_FreightTaxCode
          }
        },
        'RowVersion': model.RowVersion,
      };



// :: Ideally need to get a response from insert of the UID of the customer to insert back in sop brands to know th e link has taken place.
 this._demoService.updateMyobCustomer(data_test).subscribe(
        data => { this.myobCustomerUpdateData = data;
          let res = data[0];
          let new_data_object = JSON.parse(this.myobCustomerCreatedData);

          // console.log('new_data date: ' + new_data_object.date);
          // console.log('new_data Location ' + new_data_object.location);
          // remove the last 25 chars to get the inserted id.
          // get the length of the string and then splice 25 chars less from the total length.
          let location_string = new_data_object.location;
          // let data_object_length = location_string.length;
          // let start_from = data_object_length - 25;
          // let data_object_splice = location_string.slice( start_from , data_object_length);
          // this.UID_new_customer = data_object_splice;
          // console.log('Last inserted myobID: ' + this.UID_new_customer);

          // get everything after last dash 
          let slug = location_string.split('/').pop(); // 2020
          console.log('UUID slug: ' + slug);
          model.myob_id = slug;
          model.sync_with_myob = 1;

                      // TO DO LOOKUP THE RECORD AND GET ROWVERSION AND UPDATE BRAND

                                this.editBrand(model);
                                  this.refreshGrid();

          this.toastr.success('Customer Updated in Myob');
        },
        err => {
          // this.toastr.error('You need to login to MYOB again, Connection lost!');
         console.log(err.error);
        }
      );

      }; // end confirm

    };




    deleteMyobCustomerModel(model){
      // if (confirm('This will delete this company from Myob. We cannot undo this, Are you Sure?')) {
  this._demoService.deleteMyobCustomer(model).subscribe(
        data => { this.myobCustomerDeleteData = data;
          let res = data[0];
          model.myob_id = null;
          // model.sync_with_myob = 0; 
          model.RowVersion = null;
          // Set these from the global setting so I dont have to reset every time.
          model.TaxCode = this.gfunc.myob_TaxCode;
          model.FreightTaxCode= this.gfunc.myob_FreightTaxCode;
          this.editBrand(model);
            this.refreshGrid();
          this.toastr.success('Brand Deleted and Un-Linked with Myob');
        },
        err => {
          // this.toastr.error('You need to login to MYOB again, Connection lost!');
         // console.error(err);
        },
        // () => console.log('done loading Trace Types')
      );

      // }; // end confirm

    };











    refreshGrid(){ // refresh the databutton
      // this.loadList(this.doc_id);
      this.comparitor_array = []; // just empties the array. that way stop it keep adding and
      this.mapJobTableLiveClients();
      this.getMyobCustomers();
    //  this.grid.refresh();
    };

// need to change this below
editBrand(model){
  // model.job_id = this.job_id;
   this._demoService.updateBrand(model).subscribe(
     data => {  // this.trace_candidate_update = data;
       // refresh the list
      // this.getTraceCandidate(this.model.trace_candidate_id);  // created bugs...
     this.toastr.success('Company Updated');
     this.gfunc.insertLog_UpdateCompany(model); // hadled in the global functions file.
    // this.router.navigateByUrl('admin/clients', {skipLocationChange: true}).then(() =>
    // this.router.navigate(['/admin/jobs/subject/edit/' + model.subject_id + '']));
     },
     error => {
      // console.error('Error saving Event!');
       this.toastr.error('Error Updating Brand');
      return console.log(error);
     }
    // err => console.error(err),
    // () => console.log('done updates')
 );}



 getBrandsSearch(search_model){

  this.search_model = search_model;
  this.comparitor_array = []; // just empties the array. that way stop it keep adding and
  this.mapJobTableLiveClients();
  this.getMyobCustomers();
 }


// New way of rendering table data
mapJobTableLiveClients() {

this.gfunc.myobChecker();

  this.getBrandBrandTypes();
  this.getUsers();
  
let body = JSON.stringify(this.search_model)
  this.http.put<any>(this.gfunc.apiURL + '/api/brands/clients/metrics', body, httpOptions)
  // this.http.get<any>(this.gfunc.apiURL + '/api/brands/clients') // original without metrics
 .pipe(map(data => {
  // do your transformations
  this.job_table_clients = data;


// comparitor update
// this.Items = data['job_table_clients'];
this.Items = data;


 // console.log(this.Items);
// this.Address = this.Items['Address'];
// return this.myobCustomers;

// this.comparitor_array = [];
// this.baseMyobCustomers.items = DataUtil.parse.parseJson(data); 
// this.baseMyobCustomers = DataUtil.parse.parseJson(data); 
this.baseMyobCustomers =  this.Items; // set above as items....
// console.log(JSON.stringify(this.baseMyobCustomers))
//  console.log(JSON.stringify(this.Items))

if (!this.comparitor_array){this.comparitor_array = [];} 
if (!this.comparitor_array_A){this.comparitor_array_A = [];} 
// Count items and then push to the comparitor array with same being sent from the myob call.
// let  count_of_items = Object.keys(this.baseMyobCustomers).length;
let  count_of_items = this.baseMyobCustomers.length;
console.log("Count of items: " + count_of_items);

// // now loop and push to join model
for(let i=0;i < count_of_items; i++) {
let res_push = this.baseMyobCustomers[i];

// console.log("Tax code: " + res_push.SellingDetails.FreightTaxCode.UID)

  // push to holding list of invoice items, all current subject_billing_items. (no filtering as yet.)
  this.comparitor_array.push({
    CompanyName: res_push.name,
    UID: res_push.myob_id,
    RowVersion: res_push.RowVersion,
    TaxCode: res_push.TaxCode,
    FreightTaxCode: res_push.FreightTaxCode,
    // TaxCode: res_push.SellingDetails,
    // FreightTaxCode: '',
    brand_id: 'TSA' + res_push.brand_id,
    name: '',
    via: 'TSA',
    real_brand_id: res_push.brand_id,
    LastModified: res_push.updated
          });
  this.comparitor_array_A.push({
    CompanyName: res_push.name,
    UID: res_push.myob_id,
    RowVersion: res_push.RowVersion,
    TaxCode: res_push.TaxCode,
    FreightTaxCode: res_push.FreightTaxCode,
    // TaxCode: res_push.SellingDetails,
    // FreightTaxCode: '',
    brand_id: 'TSA' + res_push.brand_id,
    name: '',
    via: 'TSA',
    real_brand_id: res_push.brand_id,
    LastModified: res_push.updated
          });        

} // end brands loop.
this.comparitor_array =  this.comparitor_array;
//this.grid.refresh();
// this.toastr.success("TSA Companies pushed to comparitor array");








  this.job_table_clients.forEach(element => {
 
  
    element.primary_contact = ''; // removed undefined from table

/*
// local Client Name
this.clientLocalRecord = this.clients.filter(c => c.client_id === element.client_id);
let rs = this.clientLocalRecord;
this.changeObject = Object.assign(this.clientLocalRecord);
element.client_id  = this.changeObject[0].name;
*/

// commented out so that brand_type_id do not change to a word.
// this.btLocalRecord = this.brand_types.filter(c => c.brand_type_id === element.brand_type_id);
// this.changeObject = Object.assign(this.btLocalRecord);
//   element.brand_type_id  = this.changeObject[0].brand_type_name;

// get user counts per brand - Changes the actual Brand Type ID>...
this.userLocalRecord = this.users.filter(c => c.brand_id === element.brand_id);
this.changeObject = Object.assign(this.userLocalRecord);
let recordCount = this.changeObject.length;
element.contacts  = this.changeObject.length;



// get user counts per brand
this.userLocalRecord = this.users.filter(c => c.brand_id === element.brand_id && c.is_primary_contact == 1);
this.changeObject = Object.assign(this.userLocalRecord);
let recordCount2 = this.changeObject.length;
// element.contacts  = this.changeObject.length;
// need to filter this element objects of users to get the primary contact.
if (recordCount2 < 1){
  element.primary_contact = '-';
}else{
  for (let i = 0; i < recordCount2; i++) {
    element.primary_contact  += this.changeObject[i].first_name + ' ' + this.changeObject[i].surname + ', ';
} // end loop
}// end if


}); // end for each of all


return this.job_table_clients3;
})
 )
  .subscribe(
    results => this.job_table_clients3 = results
  );



  // // Count items and then push to the comparitor array with same being sent from the myob call.
  // let  count_of_brand_items = Object.keys(this.job_table_clients3).length;
  // // now loop and push to join model
  // for(let i=0;i < count_of_brand_items; i++) {
  //   let res = this.job_table_clients3[i];
  
  //     // push to holding list of invoice items, all current subject_billing_items. (no filtering as yet.)
  //     this.comparitor_array.push({
  //       Name: res.name,
  //       UID: res.myob_id,
  //       RowVersion: res.RowVersion,
  //       TaxCode: res.TaxCode,
  //       FreightTaxCode: res.FreightTaxCode,
  //       brand_id: res.brand_id,
  //             });
  
  // } // end brands loop.
  // this.comparitor_array =  this.comparitor_array;



}





getBrandBrandTypes(){
  this._demoService.getBrandBrandTypes().subscribe(
    data => { this.brand_types = data;
     let res = data[0];
   },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );
}

getUsers() {
  this._demoService.getUsers().subscribe(
    data => { this.users = data;
      this.usersPrimary = data;
     let res = data[0];
   },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );
}


brandView(brand_id) {
  this.router.navigate(['/admin/brands/company/view/' + brand_id + '']);
}

brandEdit(brand_id) {
  this.router.navigate(['/admin/brands/company/edit/' + brand_id + '']);
}



public getMyobCustomer(UID){
    this._demoService.getMyobCustomer(UID).subscribe(
      data => { this.myobCustomer = data;
        let res = data[0];
         this.arrCase = data as object [];  // FILL THE ARRAY WITH DATA.
         // console.log(this.arrCase);
         this.customerItem = data['Item'] ;
        // console.log(this.customerItem);
        // this.Address = this.Items['Address'];
      },
      err => {
        // this.toastr.error('You need to login to MYOB again, Connection lost!');
        console.error(err);
      },
      // () => console.log('done loading')
    );
  }



  // the declared vars
  //  myobContactListMapped: MyobContact[];
  getMyobCustomerMapped(UID) {
   this._demoService.getMyobCustomerMapped(UID)
    .subscribe((data:any) => {
       console.log(data);
     // many
       // this.myobContactListMapped = data.data;
     //single
       this.myobContactListMapped = data.data;
    });
  }


// Comparison function of two objects

public compare(obj1, obj2) {
  const commonKeys = [...new Set([...Object.keys(obj1), ...Object.keys(obj2)])];

  for (const key of commonKeys) {
    if (obj1[key] !== obj2[key]) {
      console.log('obj1[key] !== obj2[key]: ' + obj1[key].value + ' //==// ' + obj2[key].value)
      return false;
    }
  }

  return true;
  
}



difference(origObj, newObj) {
  const origObjKeyList = Object.keys(origObj),
    newObjKeyList = Object.keys(newObj);


    console.log("Object1Keys: " + origObjKeyList);
    console.log("ObjectsKeys: " + newObjKeyList);


  // if objects length is not same
        // if (origObjKeyList?.length !== newObjKeyList?.length) {
        //   console.log("// if objects length is not same");
        //   return;
        // }

  // if object keys some difference in keys
  let same_keys_dif_lenght = Object.keys(origObj).filter((val) => !Object.keys(newObj).includes(val))?.length;
  console.log(" " + same_keys_dif_lenght);

        // if (Object.keys(origObj).filter((val) => !Object.keys(newObj).includes(val))?.length) {
        //   console.log("// if object keys some difference in keys");
        //   return;
        // }

  let return_object = Object.entries(origObj).reduce(
    (acc, [key, value]) => (newObj[key] !== value ? { ...acc, ...{ [key]: newObj[key] } } : acc),
    []
  );
  console.log("Returned Object: " + JSON.stringify(return_object));
   return return_object
}

clearComparison(){
  this.comparitor_array = []; // just empties the array.
}






rowSelected(args: RowSelectEventArgs) {

  // console.log('selected data object: ' + JSON.stringify(args.data));
        //  // simply push the object/s seleceted to the  this.search_results array.
        //  if(!this.search_results){this.search_results = [];}; // set so is defined before push if empty
        //  this.search_results.push({
        //    ...args.data
        //  });
        // if (typeof args.data === 'object' && args.data !== null && args.data[0].id >= 0 ){
        //   console.log('We have a header object of data selected');
        // }

        //checks if single object
        if (typeof args.data === 'object' && args.data !== null && !args.data[0] ){
          if(!this.search_results){this.search_results = [];}; // detect if array exists.
          console.log('We have a single object of data selected');
            this.search_results.push({
            ...args.data
            });
        // this.toastr.info( this.search_results.length + ' Clicked added to search results'); 

        }

        // if an a list of objects need to count and then loop through.
        if (typeof args.data === 'object' && args.data !== null && args.data[0] ){
          console.log('We have a OBJECT of object of data selected');
          const count_selected = this.grid.getSelectedRecords().length;
          console.log('count: ' + count_selected); // lenth is used for myob comparitor array
          const length = Object.keys(args.data).length
          console.log('length: ' + length);
        
          // now loop and insert individually
          if(!this.search_results){this.search_results = [];}; // detect if array exists.
          for(let i=0;i < length; i++) {
            this.search_results.push({
            ...args.data[i]
            });
            }
          //  this.toastr.info( this.search_results.length + ' Clicked added to search results');
          }



  const selectedrowindex: number[] = this.comparitor_grid.getSelectedRowIndexes();  // Get the selected row indexes.
  // alert(selectedrowindex); // To alert the selected row indexes.
  const selectedrecords: object[] = this.comparitor_grid.getSelectedRecords();  // Get the selected records.
  this.selectedrecords = this.comparitor_grid.getSelectedRecords();


  }




        // we also need to create a row deselect event to remove from args
        rowDeSelected(args: RowSelectEventArgs) {

          
          const selectedrowindex: number[] = this.comparitor_grid.getSelectedRowIndexes();  // Get the selected row indexes.
          // alert(selectedrowindex); // To alert the selected row indexes.
          const selectedrecords: object[] = this.comparitor_grid.getSelectedRecords();  // Get the selected records.
          this.selectedrecords = this.comparitor_grid.getSelectedRecords();

          // console.log('selected data object: ' + JSON.stringify(args.data));
                //  // simply push the object/s seleceted to the  this.search_results array.
              //    if(!this.search_results){this.search_results = [];}; // set so is defined before push if empty
              //  // clear the the search results. forst then re-add.
              //  this.search_results = [];
              //    this.search_results.push({
              //      ...args.data
              //    });
 
              let argData = args.data;
          if (typeof argData === 'object' && argData !== null && !argData[0] && argData !== '[]' ){
            console.log('We have a single object of data de-selected');
            let base_search_results = this.search_results
            
            // this.search_results = []; 
            // this.search_results.push({
            //   ...args.data
            //   });
            
 

              // leave items where not selected --- somehow add the ones that were already clicked before they all were removed.
              this.search_results =  this.search_results.filter(function (order) {
                // return true for salary greater than equals to 25000
                console.log('leaving IDs= ' + args.data['id'] + ' != ' + order.id);
                return order.id != args.data['id'];
              });
              // this.toastr.warning( ' Order Remved from the action list'); 
 

          // remove
          // filter and remove the selected ones from the object first.
              // let remove_unselected = this.grid.getSelectedRowIndexes();
              // // let uniqueArray = this.search_results.filter((v,i,a)=>a.findIndex(t=>(t.id === remove_unselected))===i);
            
          }    


          // if an a list of objects need to count and then loop through.
          if (typeof args.data === 'object' && args.data !== null && args.data[0] ){
            console.log('We have a OBJECT of object of data DE-selected');
            const count_selected = this.comparitor_grid.getSelectedRecords().length;
            console.log('count: ' + count_selected); // both count methods work.
            // const length = Object.keys(args.data).length
            // console.log('length: ' + length);
          
            // now loop and insert individually
       //     this.search_results = []; 
            for(let i=0;i < count_selected; i++) {
              // for(let i=0;i < count_selected; i++) { // made i 1 because was alwsays missing one
            //   this.search_results.push({
            //  ...args.data[i]
            //   });

              // leave items where not selected 
                  // this.search_results =  this.search_results.filter(function (order) {
                  // // return true for salary greater than equals to 25000
                  // console.log('leaving IDs= ' + args.data['i'].id + ' != ' + order.id);
                  // return order.id != args.data['id'];
                  // });
                  // this.search_results = this.search_results;

                               // leave items where not selected --- somehow add the ones that were already clicked before they all were removed.
              this.search_results =  this.search_results.filter(function (order) {
                // return true for salary greater than equals to 25000
                console.log('leaving IDs= ' + args.data[i]['id'] + ' != ' + order.id);
                return order.id != args.data[i]['id'];
              });
             

              }

              this.toastr.warning( ' Orders Remved from the action list'); 
          
            }


        
          }



          clearSearchResults(){
            this.search_results = [];
          }



      // Remove3d this optioni to do a darter sorter
      // toolbarClick(args: ClickEventArgs): void {
      //   if (args.item.id === 'Grid_excelexport') { // 'Grid_excelexport' -> Grid component id + _ + toolbar item name
      //       this.grid.excelExport();
      //   }
      // }



      getBrandsComboBoxClients(search_model) {
        this.search_model.brand_type_id = 2;
        this._demoService.getBrandsComboBox(search_model).subscribe(
        data => { this.brands_client = data; },
        err => console.error(err),
        // () => console.log('done loading Trace Types')
        );
        }
        



        searchPushedClients48(){
          this.search_model = {
            myob_sync_status: 2, // has been sync
            sync_with_myob: '1',
            // invoice_status_id: 3,// approved
            created_date_from: this.removeDays(2)
          }
          this.getBrandsSearch(this.search_model);
        }
        
        searchNotPushedClients48(){
          this.search_model = {
            myob_sync_status: 1, // has not been sync
            sync_with_myob: '1',
            // invoice_status_id: 3,// approved
            created_date_from: this.removeDays(2)
          }
          this.getBrandsSearch(this.search_model);
        }
        
        
        searchPushedClientsWeek(){
          this.search_model = {
            myob_sync_status: 2, // has been sync
            sync_with_myob: '1',

            // invoice_status_id: 3,// approved
            created_date_from: this.removeDays(8)
          }
          this.getBrandsSearch(this.search_model);
        }
        
        searchNotPushedClientsWeek(){
          this.search_model = {
            myob_sync_status: 1, // has not been sync
            sync_with_myob: '1',

            // invoice_status_id: 3,// approved
            created_date_from: this.removeDays(8)
          }
          this.getBrandsSearch(this.search_model);
        }


        searchPushedClients90Days(){
          this.search_model = {
            myob_sync_status: 2, // has been sync
            sync_with_myob: '1',

            // invoice_status_id: 3,// approved
            created_date_from: this.removeDays(90)
          }
          this.getBrandsSearch(this.search_model);
        }
        
        searchNotPushedClients90Days(){
          this.search_model = {
            myob_sync_status: 1, // has not been sync
            sync_with_myob: '1',

            // invoice_status_id: 3,// approved
            created_date_from: this.removeDays(90)
          }
          this.getBrandsSearch(this.search_model);
        }
        
        addDays(days : number): Date{
          let futureDate = new Date();
          futureDate.setDate(futureDate.getDate() + days);
          return futureDate;
          }
          
          
          removeDays(days : number): Date{
          let futureDate = new Date();
          futureDate.setDate(futureDate.getDate() - days);
          return futureDate;
          }
        

 // MODAL
// start of modal windows service as a template
openModal(template: TemplateRef<any>) {
  // small upgrade to disable background click on open modal background
  const config = { backdrop: true, ignoreBackdropClick: true, class: 'gray modal-lg' };
  this.modalRef = this.modalService.show(template, config);
}

// :: Parent / Child modal test
closeParentModel() {
  // alert('parent component function.');
  this.modalRef.hide();
 // this.refreshGrid(); // resets the grid if updated and closed.
//  this.updateTypeClick = false; // closes the div
};



listAction_RemoveClientsMyobOnly(){
  if (confirm('Are you sure you want to delete all these clients from MYOB and update local data. Warning you cannot undo this? x: ' + this.gfunc.set_max_sync_number)) {
      
    for (let i = 0; i < this.search_results.length; i++) {
    // for (let i = 0; i < this.gfunc.set_max_sync_number; i++) {
        // console.log ("Block statement execution no." + this.pending_agents_invoices_payments[i].subject_number);
        console.log(JSON.stringify(this.search_results[i]))
  
//  new function here.
        // this.deletePaymentAndWorkOrderPayment(this.pending_agents_invoices_payments[i])
        // this.deleteMyobServiceInvoiceModel(this.search_results[i])
        let result = this.search_results[i];
        // this.deleteMyobServiceWorkOrderModel(this.search_results[i])
        this.deleteMyobCustomerModel(result)
        
        // console.log ("Block statement execution no." + this.search_results[i].work_order_number);          
        // console.log ("Block statement execution no." + i)          
          }
  // this.getPendingAgentsInvoicesPayments()

}

}





}